import { type ReactElement, useEffect, useRef, useState } from 'react';

type StickyPosition = 'top' | 'bottom';

interface UseStickyOptions {
  position?: StickyPosition;
}

export const useIsSticky = ({ position = 'top' }: UseStickyOptions = {}) => {
  const markerRef = useRef<HTMLDivElement | null>(null);
  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    if (!markerRef.current) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsSticky(!entry.isIntersecting);
      },
      {
        threshold: 0,
        rootMargin: position === 'top' ? '0px 0px 0px 0px' : '0px 0px -1px 0px',
      }
    );

    observer.observe(markerRef.current);
    return () => observer.disconnect();
  }, [position]);

  const marker: ReactElement = (
    <div ref={markerRef} style={{ height: 1, pointerEvents: 'none' }} />
  );

  return { marker, isSticky };
};
